module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--1-aea20dc8c45f8b6d9099cf41caa99525.jpg";